/**
 * Constants related to engagement telemetry logging. If you find yourself reusing the same string over and over in engagement telemetry logs it should be defined here instead.
 * This is also convenient for experiments that have to define which engagement telemetry logs they want to track in IExperimentDefinition.
 */ /** Identifies how a copy/cut operation was initiated in the canvas grid. */ export var GridCopySource = /*#__PURE__*/ function(GridCopySource) {
    GridCopySource["Keyboard"] = "keyboard";
    GridCopySource["ContextMenu"] = "contextMenu";
    return GridCopySource;
}({});
export const EngagementTelemetryConstants = {
    /** Action Creators */ RoutingActionCreator: "RoutingActionCreator",
    PortfolioActionCreator: "PortfolioActionCreator",
    /** Modules */ TeamsApp: "TeamsApp",
    OutlookApp: "OutlookApp",
    OfficeApp: "OfficeApp",
    MetaOSHost: "MetaOSHost",
    WebApp: "WebApp",
    BucketModule: "BucketModule",
    BasicBucketModule: "BasicBucketModule",
    BasicPlanModule: "BasicPlanModule",
    PlannerTaskModule: "PlannerTaskModule",
    PremiumPlanModule: "PremiumPlanModule",
    PortfolioModule: "PortfolioModule",
    GroupsModule: "GroupsModule",
    PlanModule: "PlanModule",
    PlanScenarioModule: "PlanScenarioModule",
    UndoRedoScenarioModule: "UndoRedoScenarioModule",
    CustomViewScenarioModule: "CustomViewScenarioModule",
    /** Undo/Redo */ UndoStarted: "UndoStarted",
    RedoStarted: "RedoStarted",
    UndoCompleted: "UndoCompleted",
    RedoCompleted: "RedoCompleted",
    UndoExpired: "UndoExpired",
    RedoExpired: "RedoExpired",
    /** Charts */ MembersChart: "MembersChart",
    BucketsChart: "BucketsChart",
    /** Goals */ CreateGoal: "CreateGoal",
    /* Bucket */ BucketDisplayNameUpdated: "BucketDisplayNameUpdated",
    /** A bucket's background color was set or changed (the specific color is intentionally not logged). */ BucketColorUpdated: "BucketColorUpdated",
    /** A bucket's background color was removed / set to no color. */ BucketColorRemoved: "BucketColorRemoved",
    /** Task */ AddToMyDay: "AddToMyDay",
    RemoveFromMyDay: "RemoveFromMyDay",
    StarTask: "StarTask",
    UnstarTask: "UnstarTask",
    CreateTask: "CreateTask",
    TaskHierarchyOperation: "TaskHierarchyOperation",
    UpdateTask: "UpdateTask",
    DeleteTask: "DeleteTask",
    UpdatePlanRetryAttempted: "UpdatePlanRetryAttempted",
    UpdatePlanRetrySucceeded: "UpdatePlanRetrySucceeded",
    UpdateTaskRetryAttempted: "UpdateTaskRetryAttempted",
    UpdateTaskRetrySucceeded: "UpdateTaskRetrySucceeded",
    CreateBucket: "CreateBucket",
    DeleteBucket: "DeleteBucket",
    CreatePlan: "CreatePlan",
    CreatePlanFromTemplate: "CreatePlanFromTemplate",
    PlanCalendarCreate: "PlanCalendarCreate",
    PlanCalendarEdit: "PlanCalendarEdit",
    WorkingHoursSectionStartChange: "WorkingHoursSectionStartChange",
    WorkingHoursSectionEndChange: "WorkingHoursSectionEndChange",
    WorkingHoursSectionTimeZoneChange: "WorkingHoursSectionTimeZoneChange",
    MovePlanToExistingContainerSucceeded: "MovePlanToExistingContainerSucceeded",
    CreatePortfolio: "CreatePortfolio",
    TaskDetailsExternalContextLinkClicked: "TaskDetailsExternalContextLinkClicked",
    MeetingCitationLinkClicked: "MeetingCitationLinkClicked",
    ExternalContextLink: "ExternalContextLink",
    BucketTitleUpdated: "BucketTitleUpdated",
    BucketOrderHintUpdated: "BucketOrderHintUpdated",
    DeleteBucketWithPublishedTasks: "DeleteBucketWithPublishedTasks",
    AddAttachment: "AddAttachment",
    EditAttachment: "EditAttachment",
    AttachmentClicked: "AttachmentClicked",
    TaskDeepLinkClicked: "TaskDeepLinkClicked",
    PlanDeepLinkClicked: "PlanDeepLinkClicked",
    TaskLinkCopied: "TaskLinkCopied",
    AddLabelToTask: "AddLabelToTask",
    RemoveLabelFromTask: "RemoveLabelFromTask",
    TaskReactivated: "TaskReactivated",
    TaskCompleted: "TaskCompleted",
    TaskProgressChanged: "TaskProgressChanged",
    TaskAssigned: "TaskAssigned",
    TaskUpdated: "TaskUpdated",
    BulkUpdateTaskField: "BulkUpdateTaskField",
    TaskDetailsUpdated: "TaskDetailsUpdated",
    RecurrenceCanceledDueDate: "RecurrenceCanceledDueDate",
    RecurrenceOptionSelected: "RecurrenceOptionSelected",
    UnscheduleTask: "UnscheduleTask",
    TaskCard: "TaskCard",
    TaskCardContextMenu: "TaskCardContextMenu",
    TaskCardContextMenuClicked: "TaskCardContextMenuClicked",
    ChecklistItemCompleted: "ChecklistItemCompleted",
    TaskDetailsEditor: "TaskDetailsEditor",
    TaskDetailsEditorOpened: "TaskDetailsEditorOpened",
    TaskDetailsEditorTabChanged: "TaskDetailsEditorTabChanged",
    TaskNotesRibbonCommandUsed: "TaskNotesRibbonCommandUsed",
    TaskNotesShortcutUsed: "TaskNotesShortcutUsed",
    DeleteTasksWithOrphanedBuckets: "DeleteTasksWithOrphanedBuckets",
    /** Group */ CreateGroup: "CreateGroup",
    /** Task Board */ BoardColumnGroup: "BoardColumnGroup",
    DeleteUncategorizedBucket: "DeleteUncategorizedBucket",
    ToggleColumnGroupSection: "ToggleColumnGroupSection",
    TaskBoardDnd: "TaskBoardDnd",
    // Authentication
    ClaimChallengeReceived: "ClaimChallengeReceived",
    /* App Lifecycle */ /** When the app bootstraps */ Bootstrap: "Bootstrap",
    /** Group Picker */ GroupPicker: "GroupPicker",
    GroupLinkClicked: "GroupLinkClicked",
    /** Pagination */ NextPageClicked: "NextPageClicked",
    PreviousPageClicked: "PreviousPageClicked",
    /** Plan Settings */ PlanSettings: "PlanSettings",
    /** Delta Sync */ DeltaSyncCookieExpiredError: "DeltaSyncCookieExpiredError",
    /** Filters */ AssignmentFilterSection: "AssignmentFilterSection",
    BucketFilterSection: "BucketFilterSection",
    CategoryFilterSection: "CategoryFilterSection",
    CustomFieldChoiceFilterSection: "CustomFieldChoiceFilterSection",
    CustomFieldDateFilterSection: "CustomFieldDateFilterSection",
    CustomFieldFlagFilterSection: "CustomFieldFlagFilterSection",
    DueDateFilterSection: "DueDateFilterSection",
    FinishDateFilterSection: "FinishDateFilterSection",
    StartDateFilterSection: "StartDateFilterSection",
    GoalFilterSection: "GoalFilterSection",
    PriorityFilterSection: "PriorityFilterSection",
    ProgressFilterSection: "ProgressFilterSection",
    TaskFilterMenu: "TaskFilterMenu",
    ClearFilters: "ClearFilters",
    FilterClicked: "FilterClicked",
    FilterByKeyword: "FilterByKeyword",
    DynamicFilterAdded: "DynamicFilterAdded",
    DynamicFilterToggled: "DynamicFilterToggled",
    DynamicFilterRemoved: "DynamicFilterRemoved",
    DynamicFilterSaved: "DynamicFilterSaved",
    SavedDynamicFilterApplied: "SavedDynamicFilterApplied",
    SavedDynamicFilterEdited: "SavedDynamicFilterEdited",
    SavedDynamicFilterDeleted: "SavedDynamicFilterDeleted",
    /** Custom Views */ ApplyCustomView: "ApplyCustomView",
    CreateCustomView: "CreateCustomView",
    ResetCustomView: "ResetCustomView",
    /** ModernGroup */ CreateModernGroup: "CreateModernGroup",
    ModernGroupModule: "ModernGroupModule",
    // MyPlans
    MyPlansHub: "MyPlansHub",
    PlanClicked: "PlanClicked",
    ShowMoreClicked: "ShowMoreClicked",
    KeywordFilterUsed: "KeywordFilterUsed",
    KeepPlanButtonClicked: "KeepPlanButtonClicked",
    // Notifications
    NotificationBar: "NotificationBar",
    ErrorBarShown: "ErrorBarShown",
    WarningBarShown: "WarningBarShown",
    UserDismissedToast: "UserDismissedToast",
    TimeoutDismissedToast: "TimeoutDismissedToast",
    BasicPlanConversionToast: "BasicPlanConversionToast",
    // Notification settings
    NotificationSettingsDialog: "NotificationSettingsDialog",
    NotificationSettingSaved: "NotificationSettingSaved",
    // Upsell
    FetchPremiumSubscriptionStatus: "FetchPremiumSubscriptionStatus",
    AcquirePremiumTrialSucceeded: "AcquirePremiumTrialSucceeded",
    TrialConversionSucceeded: "TrialConversionSucceeded",
    BasicPlanConversionSucceeded: "BasicPlanConversionSucceeded",
    SessionShowsTryProject: "SessionShowsTryProject",
    SessionExpiredTrial: "SessionExpiredTrial",
    // Upsell - RequestPremiumLicense
    RequestPremiumPlanLicenseDialog: "RequestPremiumPlanLicenseDialog",
    RequestPremiumPlanLicenseDialogOpened: "RequestPremiumPlanLicenseDialogOpened",
    RequestPremiumLicenseSucceeded: "RequestPremiumLicenseSucceeded",
    // Upsell - ConvertPlan
    ConvertPlanDialog: "ConvertPlanDialog",
    ConvertPlanDialogOpened: "ConvertPlanDialogOpened",
    ConvertPlanDialogCompareButtonClicked: "ConvertPlanDialogCompareButtonClicked",
    ConvertPlanDialogCreatePremiumPlanButtonClicked: "ConvertPlanDialogCreatePremiumPlanButtonClicked",
    ConvertPlanDialogStartTrialAndConvertPlanButtonClicked: "ConvertPlanDialogStartTrialAndConvertPlanButtonClicked",
    ConvertPlanToastNotificationViewButtonClicked: "ConvertPlanToastNotificationViewButtonClicked",
    // Upsell - TryPremiumModal
    TryPremiumModal: "TryPremiumModal",
    TryPremiumModalOpened: "TryPremiumModalOpened",
    TryPremiumModalStartTrialClicked: "TryPremiumModalStartTrialClicked",
    TryPremiumModalCompareButtonClicked: "TryPremiumModalCompareButtonClicked",
    TryPremiumModalLearnMoreClicked: "TryPremiumModalLearnMoreClicked",
    // Upsell - UpsellStatusModal
    UpsellStatusModal: "UpsellStatusModal",
    UpsellStatusModalBuyNowClicked: "UpsellStatusModalBuyNowClicked",
    UpsellStatusModalRequestLicenseClicked: "UpsellStatusModalRequestLicenseClicked",
    UpsellStatusModalManageSubscriptionClicked: "UpsellStatusModalManageSubscriptionClicked",
    UpsellStatusModalLearnMoreClicked: "UpsellStatusModalLearnMoreClicked",
    // Upsell - PlanUpgraded
    PlanUpgradedDialog: "PlanUpgradedDialog",
    PlanUpgradedDialogOpened: "PlanUpgradedDialogOpened",
    PlanUpgradedDialogdDismissed: "PlanUpgradedDialogdDismissed",
    PlanUpgradedDialogCompareButtonClicked: "PlanUpgradedDialogCompareButtonClicked",
    PlanUpgradedDialogGoToPlanButtonClicked: "PlanUpgradedDialogGoToPlanButtonClicked",
    // Usage Logging Constants
    TaskReactivateButtonClicked: "TaskReactivateButtonClicked",
    TaskCompleteButtonClicked: "TaskCompleteButtonClicked",
    DeleteAttachment: "DeleteAttachment",
    TaskProgressUpdated: "TaskProgressUpdated",
    TaskPercentCompleteUpdated: "TaskPercentCompleteUpdated",
    TaskBucketUpdated: "TaskBucketUpdated",
    TaskPriorityUpdated: "TaskPriorityUpdated",
    TaskStartDateUpdated: "TaskStartDateUpdated",
    TaskFinishDateUpdated: "TaskFinishDateUpdated",
    TaskDueDateUpdated: "TaskDueDateUpdated",
    TaskLabelsChanged: "TaskLabelsChanged",
    TaskDurationUpdated: "TaskDurationUpdated",
    TaskEffortUpdated: "TaskEffortUpdated",
    TaskSprintUpdated: "TaskSprintUpdated",
    TaskCustomFieldUpdated: "TaskCustomFieldUpdated",
    RecurrenceDueDateUpdated: "RecurrenceDueDateUpdated",
    TaskDetailsContextMenuClicked: "TaskDetailsContextMenuClicked",
    TaskDetailsChatPanelButtonClicked: "TaskDetailsChatPanelButtonClicked",
    TaskCommentPosted: "TaskCommentPosted",
    OpenTaskEditor: "OpenTaskEditor",
    ToggleTaskEditorRenderMode: "ToggleTaskEditorRenderMode",
    ProjectTaskDetails: "ProjectTaskDetails",
    CopyLinkToTask: "CopyLinkToTask",
    CopyTaskDialogOpened: "CopyTaskDialogOpened",
    CustomRecurrenceDialogOpened: "CustomRecurrenceDialogOpened",
    MoveTaskDialogOpened: "MoveTaskDialogOpened",
    DeleteRecurringTaskDialogOpened: "DeleteRecurringTaskDialogOpened",
    DeleteRecurringTaskDialogClosed: "DeleteRecurringTaskDialogClosed",
    TaskRowContextMenuClicked: "TaskRowContextMenuClicked",
    NewPlanButtonClicked: "NewPlanButtonClicked",
    ExistingPlanButtonClicked: "ExistingPlanButtonClicked",
    NewPortfolioButtonClicked: "NewPortfolioButtonClicked",
    PlanPinned: "PlanPinned",
    ExecuteTaskWorkflowAsyncInBasicPlan: "ExecuteTaskWorkflowAsyncInBasicPlan",
    CopyPlanButtonClicked: "CopyPlanButtonClicked",
    PlanTitleBreadcrumbClicked: "PlanTitleBreadcrumbClicked",
    ExportPlanButtonClicked: "ExportPlanButtonClicked",
    PlanSettingsClicked: "PlanSettingsClicked",
    MyPlansBreadcrumbClicked: "MyPlansBreadcrumbClicked",
    ConnectedPlanMenuItemClicked: "ConnectedPlanMenuItemClicked",
    PLinkEntryPointClicked: "PLinkEntryPointClicked",
    PLinkOperationStarted: "PLinkOperationStarted",
    PLinkOperationCompleted: "PLinkOperationCompleted",
    PLinkOpenConnectedPlanClicked: "PLinkOpenConnectedPlanClicked",
    PLinkConnectedPlansMenuOpened: "PLinkConnectedPlansMenuOpened",
    PlanContextDropdownClicked: "PlanContextDropdownClicked",
    CopyPlanLinkButtonClicked: "CopyPlanLinkButtonClicked",
    CopySessionIdButtonClicked: "CopySessionIdButtonClicked",
    AboutPlannerButtonClicked: "AboutButtonClicked",
    EngagementButtonClicked: "EngagementButtonClicked",
    JoinPlanButtonClicked: "JoinPlanButtonClicked",
    TrialButtonClicked: "TrialButtonClicked",
    // Task Forms
    FormsRequirementsIFrameDialogOpened: "FormsRequirementsIFrameDialogOpened",
    FormsRequirementsIFrameDialogClosed: "FormsRequirementsIFrameDialogClosed",
    FormsRequirementsIFrameDialogSubmit: "FormsRequirementsIFrameDialogSubmit",
    FormsRequirementsIFrameDialogFormReady: "FormsRequirementsIFrameDialogFormReady",
    FormsRequirementsIFrameFormClicked: "FormsRequirementsIFrameFormClicked",
    FormsRequirementsIFrameDialogError: "FormsRequirementsIFrameDialogError",
    FormsRequirementIFrameDialogTokenFetched: "FormsRequirementIFrameDialogTokenFetched",
    FormsRequirementIFrameDialogTokenFetchFailed: "FormsRequirementIFrameDialogTokenFetchFailed",
    FormsRequirementIFrameDialogFormSubmitted: "FormsRequirementIFrameDialogFormSubmitted",
    // Shared containers
    AssignTaskSuccessful: "AssignTaskSuccessful",
    AssignTaskBlockedByShareFile: "AssignTaskBlockedByShareFile",
    AssignTaskBlockedByAddNonMember: "AssignTaskBlockedByAddNonMember",
    // Left Nav
    LeftNav: "LeftNav",
    OptionClicked: "OptionClicked",
    SwitchView: "SwitchView",
    // Open plan logging
    OpenPlanFromPersistedRoute: "OpenPlanFromPersistedRoute",
    OpenBasicPlan: "OpenBasicPlan",
    OpenPlan: "OpenPlan",
    // Open portfolio logging
    OpenPortfolio: "OpenPortfolio",
    // Create task from message
    CreateTaskFromMessage: "CreateTaskFromMessage",
    // Remove teams tab
    RemoveTeamsTabForBasicPlan: "RemoveTeamsTabForBasicPlan",
    RemoveTeamsTabForUnifiedPlan: "RemoveTeamsTabForPlan",
    RemoveTeamsTabForPremiumPlan: "RemoveTeamsTabForPremiumPlan",
    RemoveTeamsTabForNonLinkedPlan: "RemoveTeamsTabForNonLinkedPlan",
    // Create teams tab
    CreateBlankTab: "CreateBlankTab",
    LinkPlanToTab: "LinkPlanToTab",
    CreateTabWithNewPlan: "CreateTabWithNewPlan",
    CreateTabWithExistingPlan: "CreateTabWithExistingPlan",
    // Teams Tab Landing Page Experience
    TeamsTabLandingExperience: "TeamsTabLandingExperience",
    // GSD
    GsdPlanOpened: "GsdPlanOpened",
    TaskAssignedToCopilot: "TaskAssignedToCopilot",
    TaskUnassignedFromCopilot: "TaskUnassignedFromCopilot",
    CopilotResultUpdateSelected: "CopilotResultUpdateSelected",
    CopilotResultStopSelected: "CopilotResultStopSelected",
    CopilotResultLiked: "CopilotResultLiked",
    CopilotResultDisliked: "CopilotResultDisliked",
    GenerateCopilotTasks: "GenerateCopilotTasks",
    RegenerateCopilotTasks: "RegenerateCopilotTasks",
    CopilotTaskCreationCancelled: "CopilotTaskCreationCancelled",
    EditGoalsSection: "EditGoalsSection",
    EditHighlightedGoalInCopilotPage: "EditHighlightedGoalInCopilotPage",
    EditHighlightInHighlightedTextField: "EditHighlightInHighlightedTextField",
    ProjectHomeResourcesEditButtonClicked: "ProjectHomeResourcesEditButtonClicked",
    AssignToCopilotButtonClicked: "AssignToCopilotButtonClicked",
    AttachResourceItem: "AttachResourceItem",
    DeleteResourceItem: "DeleteResourceItem",
    LoopPageCreated: "LoopPageCreated",
    UpdatedTaskWithExecutionResponse: "UpdatedTaskWithExecutionResponse",
    LoopResponseSection: "LoopResponseSection",
    AIGeneratedTaskSection: "AIGeneratedTaskSection",
    CreatePlanStorage: "CreatePlanStorage",
    // Copilot Sidecar
    TaskCitationCard: "TaskCitationCard",
    //Baseline Usage engagement constants for logging
    BaselineDetailsView: "BaselineDetailsView",
    BaselineProjectSummaryView: "BaselineProjectSummaryView",
    SpotLightTab: "SpotLightTab",
    GridViewCommandBar: "GridViewCommandBar",
    HideBaselineColumnButtonClicked: "HideBaselineColumnButtonClicked",
    CompareAllTasksButtonClicked: "CompareAllTasksButtonClicked",
    SelectedBaselineDetailsView: "SelectedBaselineDetailsView",
    InsightCardClicked: "InsightCardClicked",
    // Share plan
    AddMember: "AddMember",
    RemoveMember: "RemoveMember",
    PlanStatusSection: "PlanStatusSection",
    ShareButtonClicked: "ShareButtonClicked",
    AddPeopleButtonClicked: "AddPeopleButtonClicked",
    AddAgentsButtonClicked: "AddAgentsButtonClicked",
    AddPublishAsTemplateButtonClicked: "AddPublishAsTemplateButtonClicked",
    PublishPlanAsTemplateSubmitted: "PublishPlanAsTemplateSubmitted",
    AddAgentButtonClicked: "AddAgentButtonClicked",
    ExternalAgentsView: "ExternalAgentsView",
    AddToPlanClicked: "AddToPlanClicked",
    RemoveAgentClicked: "RemoveAgentClicked",
    SharePlanDialogContainer: "SharePlanDialogContainer",
    ShareMenuButton: "ShareMenuButton",
    SharePlanExistingGroup: "SharePlanExistingGroup",
    SharePlanNewGroup: "SharePlanNewGroup",
    // Campaign
    CampaignCalloutContainer: "CampaignCalloutContainer",
    CampaignShownToUser: "CampaignShownToUser",
    CampaignCtaButtonClicked: "CampaignCtaButtonClicked",
    CampaignDismissed: "CampaignDismissed",
    // iCalendar
    ICalendarDialog: "ICalendarDialog",
    ICalendarPublishEnabled: "ICalendarPublishEnabled",
    ICalendarPublishDisabled: "ICalendarPublishDisabled",
    PublishPlanTasksToOutlookCalendarClicked: "PublishTasksToOutlookCalendarClicked",
    // Grid customizations
    ReorderGridColumn: "ReorderGridColumn",
    ReorderGridColumnKeyboard: "ReorderGridColumnKeyboard",
    ResizeGridColumn: "ResizeGridColumn",
    AddGridColumn: "AddGridColumn",
    HideGridColumn: "HideGridColumn",
    SortGridColumn: "SortGridColumn",
    ClearGridSort: "ClearGridSort",
    CanvasTaskGrid: "CanvasTaskGrid",
    AddColumnHeaderClicked: "AddColumnHeaderClicked",
    NewCustomFieldButtonClicked: "NewCustomFieldButtonClicked",
    // Grid premium capabilities (gated by EnablePremiumCapabilitiesInGrid)
    InsertTask: "InsertTask",
    ReorderTaskRow: "ReorderTaskRow",
    // Canvas Grid: task-level (full-row) Copy/Cut/Paste/Move (CCP)
    GridCopyInitiated: "GridCopyInitiated",
    GridCutInitiated: "GridCutInitiated",
    GridPasteCompleted: "GridPasteCompleted",
    GridPasteError: "GridPasteError",
    GridMoveTaskConfirmed: "GridMoveTaskConfirmed",
    GridMoveTaskFailed: "GridMoveTaskFailed",
    CopyTaskDialogSubmitted: "CopyTaskDialogSubmitted",
    GridCutCancelled: "GridCutCancelled",
    // Canvas Grid: cell-level (single/multi-cell) Copy/Paste (CCP)
    GridCellCopyCompleted: "GridCellCopyCompleted",
    GridCellPasteCompleted: "GridCellPasteCompleted",
    // Controls
    HighlightedTextField: "HighlightedTextField",
    // Status Reports
    StatusReport: "StatusReport",
    ViewAllReports: "ViewAllReports",
    GenerateNewsletter: "GenerateNewsletter",
    GenerateReport: "GenerateReport",
    OpenReport: "OpenReport",
    DeleteReport: "DeleteReport",
    ReportSectionsDropdownClicked: "ReportSectionsDropdownClicked",
    ReportParameters: "ReportParameters",
    KeepReport: "KeepReport",
    DiscardReport: "DiscardReport",
    ViewReport: "ViewReport",
    // Agent task Assignment
    AssignTaskToAgent: "AssignTaskToAgent",
    UnassignTaskFromAgent: "UnassignTaskFromAgent",
    // FAB Menu for PMA
    FABMenu: "FABMenu",
    PlannerCopilot: "PlannerCopilot",
    PlannerCopilotSidecarOpened: "PlannerCopilotSidecarOpened",
    SmartFilterEntryPointClicked: "SmartFilterEntryPointClicked",
    PlannerCopilotDabRendered: "PlannerCopilotDabRendered",
    PlannerCopilotDabSuggestionClicked: "PlannerCopilotDabSuggestionClicked",
    PlannerCopilotDabDefaultExpandedShown: "PlannerCopilotDabDefaultExpandedShown",
    FABMenuChatClicked: "FABMenuChatClicked",
    FABMenuChatSuggestionClicked: "FABMenuChatSuggestionClicked",
    FABMenuChatInputSent: "FABMenuChatInputSent",
    FABMenuGoalsSuggestionClicked: "FABMenuGoalsSuggestionClicked",
    FABMenuGroundingResourcesClicked: "FABMenuGroundingResourcesClicked",
    FABMenuPMATaskSuggestionsClicked: "FABMenuPMATaskSuggestionsClicked",
    // Grounding Resources
    DeleteGroundingResourceItem: "DeleteGroundingResourceItem",
    AttachGroundingResourceItem: "AttachGroundingResourceItem",
    // MyTasks engagement events
    MyTasksEnableNewExperience: "MyTasksEnableNewExperience",
    MyTasksDisableNewExperience: "MyTasksDisableNewExperience",
    MyTasksDndReorder: "MyTasksDndReorder",
    MyTasksCrossGroupDrop: "MyTasksCrossGroupDrop",
    MyTasksStarTask: "MyTasksStarTask",
    MyTasksUnstarTask: "MyTasksUnstarTask",
    MyTasksSwitchViewType: "MyTasksSwitchViewType",
    // Custom Field Definitions
    CreateCustomFieldDefinition: "CreateCustomFieldDefinition",
    UpdateCustomFieldDefinition: "UpdateCustomFieldDefinition",
    DeleteCustomFieldDefinition: "DeleteCustomFieldDefinition",
    DeleteCustomFieldDefinitionConfirmationDialog: "DeleteCustomFieldDefinitionConfirmationDialog",
    // MyTasks engagement events (Phase 2)
    MyTasksEntryRoute: "MyTasksEntryRoute",
    MyTasksOpenTaskDetails: "MyTasksOpenTaskDetails",
    MyTasksSwitchPivot: "MyTasksSwitchPivot",
    MyTasksChangeGrouping: "MyTasksChangeGrouping",
    MyTasksChangeSort: "MyTasksChangeSort",
    // MyTasks opt-out survey
    MyTasksOptOutSurveyTriggered: "MyTasksOptOutSurveyTriggered",
    // MyTasks engagement events (Phase 3)
    MyTasksCompleteTask: "MyTasksCompleteTask",
    MyTasksReactivateTask: "MyTasksReactivateTask",
    MyTasksCreateTask: "MyTasksCreateTask",
    // Timeline view
    TimelineTaskBarClicked: "TimelineTaskBarClicked",
    TimelineTaskBarDragged: "TimelineTaskBarDragged",
    TimelineExpanderDragged: "TimelineExpanderDragged",
    TimelineZoomLevelChanged: "TimelineZoomLevelChanged",
    TimelineScrollToTask: "TimelineScrollToTask",
    TimelineGoToDate: "TimelineGoToDate",
    // Team view
    TeamViewTaskBarClicked: "TeamViewTaskBarClicked",
    TeamViewTaskBarDragged: "TeamViewTaskBarDragged",
    TeamViewExpanderDragged: "TeamViewExpanderDragged",
    TeamViewZoomLevelChanged: "TeamViewZoomLevelChanged",
    TeamViewGoToDate: "TeamViewGoToDate",
    TeamViewBandCollapseChanged: "TeamViewBandCollapseChanged",
    TeamViewUnscheduledTaskScheduled: "TeamViewUnscheduledTaskScheduled",
    TeamViewScheduleCancelled: "TeamViewScheduleCancelled",
    TeamViewUnscheduledColumnVisibilityChanged: "TeamViewUnscheduledColumnVisibilityChanged",
    TeamViewUnscheduledPaneCompactModeChanged: "TeamViewUnscheduledPaneCompactModeChanged",
    TeamViewUnscheduledPaneHideCompletedTasksChanged: "TeamViewUnscheduledPaneHideCompletedTasksChanged",
    // Task dependencies
    DependencyCreated: "DependencyCreated",
    DependencyRemoved: "DependencyRemoved",
    DependencyConstraintUpdated: "DependencyConstraintUpdated",
    // Plan view
    PlanViewGroupByUpdated: "PlanViewGroupByUpdated",
    // Conditional coloring
    ConditionalColoringDialogOpened: "ConditionalColoringDialogOpened",
    ConditionalColoringRuleAdded: "ConditionalColoringRuleAdded",
    ConditionalColoringRuleDeleted: "ConditionalColoringRuleDeleted",
    ConditionalColoringRulesSubmitted: "ConditionalColoringRulesSubmitted",
    // App refresh
    AppRefresh: "AppRefresh"
};
/**
 * List of usage events that are considered "core actions" for analytics purposes.
 * It is defined as all create/update actions on task/bucket/plan objects.
 */ export const UsageCoreActions = [
    // Core task actions
    EngagementTelemetryConstants.CreateTask,
    // Core bucket actions
    EngagementTelemetryConstants.CreateBucket,
    // Core plan actions
    EngagementTelemetryConstants.CreatePlan,
    EngagementTelemetryConstants.CreatePlanFromTemplate
];
